import { Directive, Input } from '@angular/core';
import { BaseValidator } from './base.directive';
import { Validator, FormControl, ValidationErrors, NG_VALIDATORS } from '@angular/forms';
import { ValidationTypes } from './validator-const.model';
import { TranslationService } from '../../common/services/translation.service';

@Directive({
    selector: `[cpqNoWhiteSpace]`,
    providers: [{ provide: NG_VALIDATORS, useExisting: CpqNoWhiteSpaceDirective, multi: true }],
    standalone: false
})
export class CpqNoWhiteSpaceDirective extends BaseValidator implements Validator {

  @Input() cpqNoWhiteSpace?: boolean;
  constructor(private translationService: TranslationService) {
    super();
}

  validate(c: FormControl<string>): ValidationErrors {
    if (this.cpqNoWhiteSpace) {
      let isValid = true;
      if (c.value) {
        isValid = !(c.value.includes(' ') || c.value.includes('\t') || c.value.includes('\n'));
      }
      return isValid ? null : this.createMessage(ValidationTypes.cpqNoWhiteSpace, this.translationService.translate('Msg.CannotContainWhiteSpace'));
    } else {
      return null;
    }
  }

}
